import { AppRoutes } from './routes';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AppProvider from './providers/app';
import { Provider } from 'react-redux';
import { store } from './store';
import AuthListener from './components/Auth/AuthListener';
import { LoadScript } from '@react-google-maps/api';
// import Loader from './components/Elements/Loader';

// const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// const options = {
//   clientSecret: 'pi_3QWrwOIWSqV83nYB1cfm2myF_secret_zL9mmZzZcKmBY2nxe84v97Va2',
//   theme: 'stripe',
// };

function App() {
  return (
    <LoadScript
      googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      libraries={['places']}
    >
      <AppProvider>
        <Provider store={store}>
          <AuthListener />
          <AppRoutes />

          {/* <Loader /> */}
        </Provider>
      </AppProvider>
    </LoadScript>
  );
}

export default App;
